import { InputText } from 'primereact/inputtext';
import { ScrutinyTab } from '../ScrutinyTab';
import { Button } from 'primereact/button';
import { useEffect, useRef, useState } from 'react';
import { LetterShowClick } from '../../../config/Validate';
import { Toast } from 'primereact/toast';
import { TabPanel, TabView } from 'primereact/tabview';
import { getAllDetails } from '../../../service/ProductService';
import { DEGREEADDITIONSCRUTINYLIST, REENTRYSCRUTINYLIST, SCRUTINYLIST } from '../../../config/ApiConstant';
import { REENTRYNAME, SCHECK, SHOLD, SkeletonbodyTemplate, Skeletonitems, SPREPARE, SVERIFICATION } from '../../../appconfig/Settings';
import { formatDate, formatDateTime, setScrutinyActiveTab } from '../../../appconfig/AppHelper';
import { useNavigate, useParams } from 'react-router-dom';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { combinedFullNameTemplate, commonNameTemplate, dateTemplate } from '../../../appconfig/DatatableTemplateSetting';
import { DegreeAdditionScrutinyListColumns, ReEntryScrutinyListColumns, ScrutinyListColumns } from '../../../appconfig/DatatableSetting';
import { Badge } from 'primereact/badge';
import { Dialog } from 'primereact/dialog';

export const ReEntryScrutiny = () => {
    document.title = 'Re-Entry Scrutiny | GSPC';

    //Set Toast/ Filter Properties
    const toast = useRef<any>(null);
    const [globalFieldFilter, setGlobalFieldFilter] = useState<any>(null);
    const [globalFilter, setGlobalFilter] = useState<any>(null);

    //scrutinyRemainingList
    const [scrutinyRemainingList, setScrutinyRemainingList] = useState<any>([]);
    const [scrutinyRemaining, setScrutinyRemaining] = useState<any>(true);

    //duplicateata
    const [duplicateData, setDuplicateData] = useState<any>([]);
    const [duplicateModal, setDuplicateModal] = useState<any>(false);

    //currrent Yeat
    const [currentYear, setCurrentYear] = useState<any>(new Date().getFullYear());

    //tabIndex
    const [activeIndex, setActiveIndex] = useState<any>(0);

    //fileNO
    const [fileNo, setFileNo] = useState<any>(null);

    // errors
    const [errors, setErrors] = useState<any>({});

    //role
    const [roleName, setRoleName] = useState<any>(null);

    //loaders
    const [pageLoad, setPageLoad] = useState<boolean>(true);
    const [showLoading, setShowLoading] = useState<boolean>(false);

    const { status }: any = useParams();

    //navigate
    const naviagte = useNavigate();

    useEffect(() => {
        // Get Token from LocalStorage
        let token: any = localStorage.getItem('token');
        let role: any = localStorage.getItem('role');

        //Token Decode
        if (!window.cn(token)) {
            if (!window.cn(role)) {
                let roleNm = role;
                let selectedTab = atob(status);
                setActiveIndex(Number(selectedTab));
                setRoleName(roleNm);
            }
        }
    }, [status]);

  


    useEffect(() => {
        if (!window.cn(roleName) && !window.cn(activeIndex)) {
           
            getRemainingScrutinyList();
        }
    }, [roleName, activeIndex]);

    // Get Remaining Scrutiny List
    const getRemainingScrutinyList = async () => {
        try {
            setPageLoad(false);
            // List Fetch for Scrutiny Manager
        if (roleName === 'Scrutiny Manager' || (roleName === 'Sub Registar' && activeIndex === 0)) {
                const response = await getAllDetails(REENTRYSCRUTINYLIST + '?AppNm=' + REENTRYNAME + '&applicationStatusType=' + SVERIFICATION);
                if (response) {
                    setScrutinyRemainingList(response);
                    setPageLoad(true);
                }
            }

            // List Fetch for Sub-Registrar
            if (roleName === 'Sub Registar' && activeIndex === 1) {
                const response = await getAllDetails(REENTRYSCRUTINYLIST + '?AppNm=' + REENTRYNAME + '&applicationStatusType=' + SPREPARE);
                if (response) {
                    setScrutinyRemainingList(response);
                    // setActiveIndex(Number(1));
                    setPageLoad(true);
                }
            }
        } catch (error: any) {
            if (error.response) {
                //Spinner False and Set Toast
                setPageLoad(true);
                toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Could Not Load Data' });
            }
        }
    };

    const searchScrutiny = async (fileNo: any, rNo: any) => {
        setShowLoading(true);
        setScrutinyRemaining(false);

        naviagte(`/app/scrutiny/re-entry-scrutiny/${window.btoa(fileNo)}/${window.btoa(rNo)}/${window.btoa(activeIndex)}`);
    };

    //file No Template
    const regNoTemplate = (rowData: any) => {
        return (
            <>
                {!window.cn(rowData?.EntryNo) ? (
                    <div className="avatar-div">
                        <div className="emp-name link-name" onClick={() => searchScrutiny(rowData?.EntryNo, rowData?.RNo)} style={{ cursor: 'pointer' }}>
                            {rowData?.RegNo}
                        </div>
                    </div>
                ) : (
                    ''
                )}
            </>
        );
    };

    //action Template
    const actionTemplate = (rowData: any) => {
        return (
            <div className="actions">
                <Button label="Scrutiny" style={{ width: 'max-content' }} className="p-button p-button-success" onClick={() => searchScrutiny(rowData?.EntryNo, rowData?.RNo)}></Button>
            </div>
        );
    };

    const caseTemplate = (rowData: any) => {
        let checkCase = false;
        if (!window.cn(rowData.applicant_details) && !window.cn(rowData.applicant_details.LastVDate)) {
            const lastVYear = new Date(rowData.applicant_details.LastVDate).getFullYear();
            const yearDiff = currentYear - lastVYear;

            if (yearDiff >= 10 || rowData.DegNm === 'Qualified') {
                checkCase = true;
            }
        }
        return <>{!checkCase ? 'Normal Case' : 'Meeting Case'}</>;
    };

    // hidedupliactedialog
    const hideDuplicateDialog = () => {
        setDuplicateModal(false);
    };

    return (
        <>
            <ScrutinyTab mainTabLabel="Scrutiny (Re Entry)" />
            <Toast ref={toast} />

            <div className="grid crud-demo mt-4">
                <div className="col-12">
                    <div className="card">
                        {scrutinyRemaining ? (
                            <>
                                <TabView activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>
                                    <TabPanel header="Scrutiny Verification"></TabPanel>
                                    <TabPanel header="Scrutiny Check"></TabPanel>
                                </TabView>
                                {/* Datatable */}
                                {pageLoad ? (
                                    <>
                                        <DataTable
                                            value={scrutinyRemainingList}
                                            showGridlines
                                            stripedRows
                                            globalFilter={globalFilter}
                                            filters={globalFieldFilter}
                                            onFilter={(e) => setGlobalFieldFilter(e.filters)}
                                            className="datatable-responsive p-datatable-sm"
                                            emptyMessage="No Data Found"
                                            removableSort
                                        >
                                            {ReEntryScrutinyListColumns.map((col: any, i: any) => {
                                                if (col.field === 'action') {
                                                    return <Column key={col.field} field={col.field} header={col.header} body={actionTemplate} />;
                                                } else if (col.field === 'sr_no') {
                                                    return <Column key={col.field} header={col.header} body={(_, { rowIndex }) => rowIndex + 1} style={{ minWidth: '5rem' }} />;
                                                } else if (col.field === 'RegNo') {
                                                    return <Column key={col.field} field={col.field} header={col.header} body={regNoTemplate} style={{ minWidth: '5rem' }} />;
                                                } else if (col.field === 'case') {
                                                    return <Column key={col.field} field={col.field} header={col.header} body={caseTemplate} style={{ minWidth: '5rem' }} />;
                                                } else {
                                                    return <Column key={col.field} field={col.field} header={col.header} sortable filter filterPlaceholder={'Search by ' + col.header} />;
                                                }
                                            })}
                                        </DataTable>
                                    </>
                                ) : (
                                    <>
                                        {/* Skeleton Data table */}
                                        <DataTable value={Skeletonitems}>
                                            {ReEntryScrutinyListColumns.map((col: any, i: any) => (
                                                <Column key={col.field} field={col.field} header={col.header} body={SkeletonbodyTemplate} />
                                            ))}
                                        </DataTable>
                                    </>
                                )}
                            </>
                        ) : (
                            ''
                        )}
                    </div>
                </div>
            </div>

            {/* Duplicate Modal Start */}

            <Dialog visible={duplicateModal} style={{ width: '750px' }} header={'Duplicate Data'} modal onHide={hideDuplicateDialog}>
                <div className="p-2">
                    <DataTable value={duplicateData} emptyMessage="No Data Found">
                        <Column field="SrNo" header="SrNo"></Column>
                        <Column field="RegNo" header="Reg No"></Column>
                        <Column field="BOD" header="DOB" body={dateTemplate}></Column>
                        <Column field="name" header="Name" body={combinedFullNameTemplate}></Column>
                    </DataTable>
                </div>
            </Dialog>
            {/* Duplicate Modal End */}
        </>
    );
};
